export const LOGIN = "/login";
export const LOGOUT_CONFIRM = "/logout-comfirm";
export const LOGOUT = "/logout";
export const DASHBOARD = "/dashboard";
export const FILTER = "/filter";
export const CREATE_USER = "/create-user";
export const UPLOAD_FILE = "/upload-file";
export const BASINS_LIST = "/dashboard/basins-list";
export const BASIN_CREATE = "/create-basin";
export const FORMATIONS_LIST = "/dashboard/formations-list";
export const FORMATION_CREATE = "/create-formation";
export const LOCATION_CREATE = "/create-location";
export const LOCATIONS_LIST = "/dashboard/locations-list";

export const HOME = "./";

export const USERS_LIST = "/dashboard/users-list";
export const NOT_FOUND = "/not-found";

export const USER = (id: string | number) => `./user/${id}`;
export const BASIN = (id: string | number) => `./basin/${id}`;
export const FORMATION = (id: string | number) => `./formation/${id}`;
export const LOCATION = (id: string | number) => `./location/${id}`;

export const EXTRACTION = (id) => `./extraction/${id}`;
export const EXTRACTION_LIST = `/dashboard/extractions-list`;
export const CREATE_EXTRACTION = "/create-extraction";

export const SAMPLE = (id) => `./sample/${id}`;
export const SAMPLE_LIST = `/dashboard/samples-list`;
export const CREATE_SAMPLE = "/create-sample";
